'use strict';

angular.module('utils').factory('OCDomUtil', function($timeout, $document, $q, $window) {
  var DESKTOP_SCREEN_MIN_WIDTH = 992;
  var _$window = angular.element(window);

  return {
    buildHiddenIframe: function() {
      var name = 'ocIframe';
      var iframe = $document.find('iframe[name="' + name + '"]');
      if (iframe.length) {
        iframe = iframe[0];
      } else {
        iframe = document.createElement('iframe');
        iframe.name = name;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      return iframe;
    },
    setFocusOn: function(elId) {
      if (!elId) {
        return;
      }
      var el = document.getElementById(elId);
      if (el) {
        // `setTimeout` fixes troubles with focusing in some browsers.
        setTimeout(function() {
          el.focus();
        }, 10);
      }
    },
    clickAndFocusOn: function(pattern) {
      $timeout(function() {
        var el = $document.find(pattern);
        if (el.length) {
          $document.scrollToElement(el[0]);
          el.each(function() {
            var _this = $(this);
            _this.click();
            // Highlight control.
            _this.find('input:first, textarea:first, select:first').focus();
          });
        }
      });
    },
    isFlashAvailable: function() {
      try {
        var swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
        if (swf) {
          return true;
        }
      } catch (_e) {
        if (navigator.mimeTypes && navigator.mimeTypes['application/x-shockwave-flash'] && navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
          return true;
        }
      }
      return false;
    },
    scrollTo: function(elSelector, speed) {
      if (!elSelector) {
        return;
      }
      var el = $(elSelector + ':first');
      if (el.length) {
        $('html, body').animate({
          scrollTop: el.offset().top,
        }, speed || 'fast');
      }
    },
    stickyScroll: function(elSelector, marginTop) {
      if (!elSelector) {
        return;
      }
      var windowEl = $(window);
      var el = $document.find(elSelector);
      var elOffset = el.offset();
      marginTop = marginTop || 0;

      windowEl.on('scroll', function() {
        var scrollTop = windowEl.scrollTop();
        if (scrollTop >= elOffset.top - marginTop) {
          el.css({
            top: scrollTop - elOffset.top + marginTop,
          });
        } else {
          el.css({
            top: 0,
          });
        }
      });
    },
    submitThroughIframe: function(action, method, data) {
      if (!action) {
        return $q.reject();
      }

      var deferred = $q.defer();
      var iframe = this.buildHiddenIframe();
      var form = document.createElement('form');
      var node = document.createElement('input');

      $(iframe).on('load', function() {
        document.body.removeChild(iframe);
        deferred.resolve();
      });

      form.method = method || 'POST';
      form.action = action;
      form.target = iframe.name;

      if (data) {
        for (var name in data) {
          node.name = name;
          node.value = String(data[name]);
          form.appendChild(node.cloneNode());
        }
      }

      form.style.display = 'none';
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      return deferred.promise;
    },
    isMobileScreen: function() {
      return _$window.width() < DESKTOP_SCREEN_MIN_WIDTH;
    },
    onWindowScrollResize: function(callback) {
      if (angular.isFunction(callback)) {
        _$window.on('scroll resize', function() {
          callback();
        });
      }
    },
    isMobileOnResize: function($scope) {
      function onResize() {
        $scope.isMobile = $window.innerWidth <= 767;
      }
      onResize();

      angular.element($window).on('resize', function() {
        $scope.$apply(onResize);
      });
    },

    addOverlayBodyClass: function(scope, includeiOS, className) {
      var $body = angular.element('body');
      var $html = angular.element('html');
      className = className || 'has-overlay';
      $body.addClass(className);

      // We need to add the class to the <html> element too on iOS.
      // This has the side effect of scrolling to the top of the page,
      // so it is best to only do it for iOS devices.
      var iOS = $.browser.ipad || $.browser.iphone || $.browser.ipod;
      if (iOS && includeiOS) {
        $html.addClass(className);
      }

      if (scope) {
        return scope.$on('$destroy', function() {
          $body.removeClass(className);
          if (iOS && includeiOS) {
            $html.removeClass(className);
          }
        });
      }
    },

    // https://stackoverflow.com/a/13382873/1815595
    getScrollbarWidth: function() {
      var outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.width = '100px';
      outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

      document.body.appendChild(outer);

      var widthNoScroll = outer.offsetWidth;
      // force scrollbars
      outer.style.overflow = 'scroll';

      // add innerdiv
      var inner = document.createElement('div');
      inner.style.width = '100%';
      outer.appendChild(inner);

      var widthWithScroll = inner.offsetWidth;

      // remove divs
      outer.parentNode.removeChild(outer);

      return widthNoScroll - widthWithScroll;
    },

    //
    // Check if an element within a scrollable container is visible
    // The "partial" param determines whether to check for partial visibility
    //
    // https://stackoverflow.com/a/16309126/1815595
    //
    isVisibleInScrollableElement: function(container, element, partial) {
      var contHeight = container.height();
      var elemTop = element.offset().top - container.offset().top;
      var elemBottom = elemTop + element.height();

      var isTotal = elemTop >= 0 && elemBottom <= contHeight;
      var isPart = (
        (elemTop < 0 && elemBottom > 0)
        || (elemTop > 0 && elemTop <= container.height())
      ) && partial;

      return isTotal || isPart;
    },
  };
});
